export const ytHavenShouldStart = "yt-haven.should-start";
export const youTubeAlreadyAllowListed = "yt-site.already.allowlisted";
export const youTubeAutoAllowlisted = "yt-auto.allowlisted";
export const youTubeWallDetected = "yt-site.ad-wall-detected";
export const youTubeNavigation = "yt-site.navigation";
export const adShownEvent = "yt-site.ad-shown";
export const toastShownEvent = "yt-site.toast-shown";
export const contextTamperingEvent = "yt-site.context-tampering";
export const ytHavenEmbedFreeFlag = "yt-haven-embed-free";
export const ytHavenEmbedPremiumFlag = "yt-haven-embed-premium";
export const ytHavenDefaultEnabledFlag = "yt-haven-default-enabled";
export const ytHavenToggleStatePrefsKey = "yt_haven_toggle_state";
export const ytHavenToggleState = "yt-haven.toggle-state";
export const ytHavenToggleStateUpdate = "yt-haven.toggle-state-update";
export const ytHavenRecordEvent = "yt-haven.record-event";
export const ytHavenAutoAllowlistVideo = "yt-haven-allowlist-video";
export const ytHavenInfoBoxShown = "yt_haven_info_box_shown";
export const ytHavenToggleStateEnabled = "yt_haven_toggle_state_enabled";
export const ytHavenToggleStateDisabled = "yt_haven_toggle_state_disabled";
export const ytHavenFeedbackMenuOpen = "yt_haven_feedback_menu_open";
export const matchingElementFoundKey = "matchingElementFound";
export const ytHavenEmbeddedPlayerIssue = "yt-haven.embed-issue";
export const ytHavenMetaTagFound = "yt-haven.meta-tag.found";
export const ytHavenNextVideoNotFound = "yt-haven.next-video-not-found";
export const ytHavenNonEmbeddableFound = "yt-haven.non-embeddable-found";
export const ytHavenNonPlayableFound = "yt-haven.non-playable-found";
export const ytHavenIframeShown = "yt-haven.iframe-shown";
